import SymbolIcon from './SymbolIcon'
import './DateRangeField.css'

export default function DateRangeField({ start, end, formatDate, state = 'editable', open = false, onClick }) {
  const editable = state === 'editable'

  return (
    <button
      className={`date-range-field is-${state}`}
      type="button"
      onClick={editable ? onClick : undefined}
      disabled={!editable}
      aria-expanded={editable ? open : undefined}
    >
      <span>
        {start ? <span data-i18n-skip="1">{formatDate(start)}</span> : <span>TT.MM.JJJJ</span>}
        {' - '}
        {end ? <span data-i18n-skip="1">{formatDate(end)}</span> : <span>TT.MM.JJJJ</span>}
      </span>
      <SymbolIcon icon="calendar_month" className="date-range-field__icon" />
    </button>
  )
}
